import React, { useCallback } from "react";
import { DropdownProps } from "@fluentui/react-northstar";

import {
  useDeviceTesterDispatchContext,
  useDeviceTesterStateContext,
} from "../../device-tester-context-provider/DeviceTesterContextProvider";
import { DeviceTesterActionType } from "../../device-tester-context-provider/Reducer.types";

import { DeviceSelectDropdown } from "./DeviceSelectDropdown";
import { ConnectedDropdownProps } from "./DeviceSelectDropdown.types";

export const ConnectedSpeakerSelectDropdown: React.FC<ConnectedDropdownProps> =
  ({ label }) => {
    const { deviceTesterState } = useDeviceTesterStateContext();
    const { deviceTesterDispatch } = useDeviceTesterDispatchContext();

    const updateSelectedSpeaker: DropdownProps["onChange"] = useCallback(
      (_: any, data: any) => {
        if (data?.value?.["data-itemid"]) {
          deviceTesterDispatch({
            type: DeviceTesterActionType.SET_SELECTED_SPEAKER,
            speakerId: data?.value?.["data-itemid"],
          });
        }
      },
      [deviceTesterDispatch]
    );

    return (
      <DeviceSelectDropdown
        label={label}
        deviceList={deviceTesterState.deviceSettings.speakers}
        selectedDevice={deviceTesterState.deviceSettings.selectedSpeaker}
        updateSelectedDevice={updateSelectedSpeaker}
      />
    );
  };
